import axios from 'axios';

export const getEstimatesList = (
  status: number,
  construct_sub: string,
  construct_code: string,
  sales_user_id: number,
  accountant_user_id: number,
  submission_from_date: string,
  submission_end_date: string,
  billing_customer_name: string,
  contractor_name: string,
  client_charge_name: string,
  prefecture_name: string,
  address: string,
  billing_total_start: number | null,
  billing_total_end: number | null,
  current_page: number,
  display_limit: number,
  sort_field: string | null,
  sort_direction: string | null
) => {
  return axios
    .get(`/api/v1/estimates`, {
      params: {
        status,
        construct_sub,
        construct_code,
        sales_user_id,
        accountant_user_id,
        submission_from_date,
        submission_end_date,
        billing_customer_name,
        contractor_name,
        client_charge_name,
        prefecture_name,
        address,
        page: current_page,
        display_limit,
        sort_direction,
        sort_field,
        billing_total_start,
        billing_total_end
      },
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteEstimatesList = (estimates_list: any) => {
  return axios
    .post(
      `/api/v1/delete/estimates`,
      {
        estimates_list: estimates_list
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteSingleEstimate = (id: number) => {
  return axios
    .delete(`/api/v1/estimates/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const createEstimate = (
  construct_id: number,
  code: string,
  construct_sub: string,
  status: number,
  submission_date: string,
  sales_user_id: number,
  output_pdf: boolean,
  display_item_number_in_pdf: boolean,
  accountant_user_id: number,
  summary: string,
  construct_days: number,
  client_name: string,
  honorific_title: string,
  contractor_name: string,
  client_charge_name: string,
  expire_date: string,
  terms_of_trade: string,
  estimate_conditions: string,
  total_price: number,
  custom_format_id: number | null,
  items: any,
  tax_rule: number
) => {
  return axios
    .post(
      `/api/v1/estimates/${construct_id}`,
      {
        code,
        status,
        construct_sub,
        submission_date,
        sales_user_id,
        output_pdf,
        display_item_number_in_pdf,
        accountant_user_id,
        summary,
        construct_days,
        client_name,
        honorific_title,
        contractor_name,
        client_charge_name,
        expire_date,
        terms_of_trade,
        estimate_conditions,
        total_price,
        custom_format_id,
        items,
        tax_rule
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getEstimatesDetails = (id: number) => {
  return axios
    .get(`/api/v1/estimates/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const registerquotation = (mainItems: any) => {
  return axios
    .post(
      `/api/v1/create/mestimate`,
      {
        mainItems
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateEstimate = (
  estimate_id: number,
  code: string,
  construct_sub: string,
  status: number,
  submission_date: string,
  sales_user_id: number,
  output_pdf: boolean,
  display_item_number_in_pdf: boolean,
  accountant_user_id: number,
  summary: string,
  construct_days: number,
  client_name: string,
  honorific_title: string,
  contractor_name: string,
  client_charge_name: string,
  expire_date: string,
  terms_of_trade: string,
  estimate_conditions: string,
  total_price: number,
  custom_format_id: number | null,
  items: any,
  tax_rule: number
) => {
  return axios
    .put(
      `/api/v1/estimates/${estimate_id}`,
      {
        code,
        construct_sub,
        status,
        submission_date,
        sales_user_id,
        output_pdf,
        display_item_number_in_pdf,
        accountant_user_id,
        summary,
        construct_days,
        client_name,
        honorific_title,
        contractor_name,
        client_charge_name,
        expire_date,
        terms_of_trade,
        estimate_conditions,
        total_price,
        custom_format_id,
        items,
        tax_rule
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const copyEstimatesList = (
  estimate_id: number,
  construct_id: number
) => {
  return axios
    .post(
      `/api/v1/copy/estimates/${estimate_id}`,
      { construct_id },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateEstimateStatus = (estimate_id: number, status: number) => {
  return axios
    .put(
      `/api/v1/estimates/${estimate_id}/status`,
      {
        status
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
export const getExportEstimateItems = (
  selected_columns: any,
  status: number,
  construct_sub: string,
  sales_user_id: number,
  accountant_user_id: number,
  submission_from_date: string,
  submission_end_date: string,
  billing_customer_name: string,
  contractor_name: string,
  prefecture_name: string,
  address: string
) => {
  return axios
    .post(
      `/api/v1/export/estimates/list?status=${status}&construct_sub=${construct_sub}&sales_user_id=${sales_user_id}&accountant_user_id=${accountant_user_id}&submission_from_date=${submission_from_date}&submission_end_date=${submission_end_date}&billing_customer_name=${billing_customer_name}&contractor_name=${contractor_name}&prefecture_name=${prefecture_name}&address=${address}`,
      {
        selected_columns
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const createEstimateFromDocument = (enc_data: string) => {
  return axios
    .post(
      `/api/v1/import/estimate/document`,
      {
        enc_data
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getEstimatesDataToExport = (id: number) => {
  return axios
    .get(`/api/v1/export/estimate/excel/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const sendDocument = (
  email: string,
  company_name: string,
  name: string,
  document_id: number,
  message: string
) => {
  return axios
    .post(
      '/api/v1/send/document/external/share/mail',
      {
        email,
        company_name,
        name,
        document_id,
        message
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

// 実行予算から追加原価、粗利を取得
export const getAdditionalCost = (estimate_id: number) => {
  return axios
    .get(`/api/v1/working_budget/additional_cost/${estimate_id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

// 実行予算作成
export const createWorkingBudget = (estimate_id: number) => {
  return axios
    .post(`/api/v1/working_budget/create/${estimate_id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
